import styles from 'components/sections/search/SellerShopSearchResult.module.scss';
import {useEffect, useRef, useState} from "react";
import {captureException, captureMessage} from "@sentry/nextjs";
import {Axios} from "api";
import SellerShopSearchItemCard from "components/cards/search/SellerShopSearchItemCard";
import RecommendedQueries from "components/sections/search/RecommendedQueries";
import {KEY_SELLER_SHOP} from "components/sections/search/SearchResult";
import {NoSellerShopSearchResult} from "components/sections/search/NoSearchResult";
import LoadingSearchResult, {SearchResultError} from "components/sections/search/LoadingSearchResult";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "components/Loading";


const FETCH_SELLER_SHOP_CHUNK_SIZE = 20;


const SellerShopSearchResult = (props) => {
    const {query, setQuery, recommendedQueries, onItemClick} = props;
    const [sellerShopData, setSellerShopData] = useState({
        'cursor': null,
        'shops': [],
    });
    const [hasNoResult, setHasNoResult] = useState(false);
    const [error, setError] = useState(false);
    const cursorRef = useRef(null);

    const handleItemClick = (shop, itemIdx) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'SellerShopSearchResultItemClick',
            {
                creatorNickname: shop.seller_profile.nickname,
                itemIdx,
            }
        );
        onItemClick();
    };

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewSellerShopSearchResult',
            {query},
        );
    }, []);

    useEffect(() => {
        setSellerShopData({
            cursor: null,
            shops: [],
        });
        if (query) {
            cursorRef.current = null;
            setHasNoResult(false);
            fetchSellerShops(query);
        }
    }, [query]);

    const fetchSellerShops = async (query) => {
        try {
            setError(false);
            // setIsLoading(true);
            const data = {
                'size': FETCH_SELLER_SHOP_CHUNK_SIZE,
                'cursor': cursorRef.current,
                'query': query,
            }

            const res = await Axios.get(`v1/search/seller-shop`, {
                params: data
            });
            if (res.status < 400) {
                setSellerShopData(prev => {
                    return {
                        cursor: res.data.cursor || null,
                        shops: [...(prev?.shops || []), ...res.data.shops],
                    }
                });
                setHasNoResult(res.data.shops.length === 0);
                cursorRef.current = res.data.cursor;
            } else {
                captureMessage(JSON.stringify(res.data));
                setError(true);
            }
        } catch (e) {
            alert('일시적인 오류가 발생했습니다. 고객센터로 문의해주세요.');
            captureException(e);
            setError(true);
        } finally {
            // setIsLoading(false);
        }
    };

    const handleRefresh = () => {
        fetchSellerShops(query);
    };

    return (
        <div>
            {
                query
                    ?
                    (
                        error
                            ? <SearchResultError handleRefresh={handleRefresh}/>
                            :
                            (
                               (
                                        hasNoResult
                                            ? <NoSellerShopSearchResult query={query}/>
                                            :
                                            <>
                                                <InfiniteScroll
                                                    scrollThreshold={'80%'}
                                                    next={() => fetchSellerShops(query)}
                                                    hasMore={sellerShopData?.cursor}
                                                    loader={
                                                        <div>
                                                            <Loading style={{marginTop: 20, marginBottom: 20}}/>
                                                        </div>
                                                    }
                                                    style={{overflow: 'hidden'}}
                                                    dataLength={sellerShopData?.shops?.length}
                                                >
                                                    <div className={styles.container}>
                                                    {
                                                        sellerShopData?.shops?.map((shop, itemIdx) => {
                                                            return <SellerShopSearchItemCard
                                                                sellerShop={shop} key={shop.id} showPosts
                                                                onItemClick={() => handleItemClick(shop, itemIdx)}
                                                                highlightKeyword={query}
                                                            />
                                                        })
                                                    }
                                                    </div>
                                                </InfiniteScroll>
                                                <div className={styles.bottomPadding}/>
                                            </>
                                    )
                            )
                    )
                    :
                    <div className={styles.container}>
                        <RecommendedQueries
                            category={KEY_SELLER_SHOP}
                            searchQuery={setQuery}
                            recommendedQueries={recommendedQueries}
                        />
                    </div>
            }
        </div>
    );
};

export default SellerShopSearchResult;
